import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { VoucherStatus } from '#src/enums/VoucherStatusEnum'
import { getVoucherByBarcode } from '#src/services/vouchersApiService'
import { useVoucherStore } from '#src/stores/voucher/voucherStore'
import { extractVoucherPinFromBarcode } from '#src/utils/voucherUtils'
import voucherErrorParser from '#src/utils/voucherErrorParser'

const error = ref<Error | null>(null)
const errorDetails = ref<ReturnType<typeof voucherErrorParser.parse> | null>(null)

export const useVoucher = () => {
  const voucherStore = useVoucherStore()
  const { voucher } = storeToRefs(voucherStore)

  const fetchVoucher = async (tenantId: string, barcode: string) => {
    error.value = null
    voucherStore.clearVoucherData()

    try {
      const result = await getVoucherByBarcode(tenantId, barcode)
      voucherStore.setVoucher(result.data)
      voucherStore.setVoucherPin(extractVoucherPinFromBarcode(result.data.barcode))
    } catch (err) {
      error.value = err instanceof Error ? err : new Error(String(err))
      errorDetails.value = voucherErrorParser.parse(err)
      throw err
    }
  }

  const isVoucherRedeemable = () => voucher.value?.status.resolutionStatus === VoucherStatus.OPEN

  return {
    fetchVoucher,
    isVoucherRedeemable,
    error,
    errorDetails
  }
}
